import React from 'react';
import styled from 'styled-components';
import { IoStar } from 'react-icons/io5';
import SpotCoinIcon from '../../../components/common/SpotCoinIcon';
import { ModalOverlay } from '../styles/SpotStyles';

/**
 * 💰 Currency Modal Component
 * SPOT, STAR, Ticket 보유량을 표시하는 모달
 */
const CurrencyModal = ({ isOpen, onClose, spotPoints, starPoints, ticketCount }) => {
  if (!isOpen) return null;

  return (
    <ModalOverlay 
      data-modal-open="true" 
      onClick={onClose}
      style={{ zIndex: 12000 }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: 'linear-gradient(135deg, rgba(34, 31, 64, 0.98) 0%, rgba(24, 21, 54, 0.98) 100%)',
          backdropFilter: 'blur(20px)',
          borderRadius: '20px',
          padding: '24px',
          minWidth: '200px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
          display: 'flex',
          flexDirection: 'column',
          gap: '16px'
        }}
      >
        {/* SPOT */}
        <CurrencyRow>
          <CurrencyLabel>
            <SpotCoinIcon width={20} height={20} />
            <span>SPOT</span>
          </CurrencyLabel>
          <CurrencyValue>
            {spotPoints ? spotPoints.toLocaleString() : 0}
          </CurrencyValue>
        </CurrencyRow>
        
        {/* STAR */}
        <CurrencyRow>
          <CurrencyLabel>
            <IoStar color="#FFD700" size={20} />
            <span>STAR</span>
          </CurrencyLabel>
          <CurrencyValue>
            {starPoints ? starPoints.toLocaleString() : 0}
          </CurrencyValue>
        </CurrencyRow>
        
        {/* Ticket */}
        <CurrencyRow $last>
          <CurrencyLabel>
            <span style={{ fontSize: '1.2rem' }}>🎫</span>
            <span>Ticket</span>
          </CurrencyLabel>
          <CurrencyValue>
            {ticketCount ? ticketCount.toLocaleString() : 0}
          </CurrencyValue>
        </CurrencyRow>
      </div>
    </ModalOverlay>
  );
};

// Styled Components
const CurrencyRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: ${props => props.$last ? 'none' : '1px solid rgba(255,255,255,0.1)'};
`;

const CurrencyLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  
  span {
    color: #FFD700;
    font-size: 0.9rem;
    font-weight: 600;
  }
`;

const CurrencyValue = styled.span`
  color: #FFF;
  font-size: 1.1rem;
  font-weight: 700;
`;

export default CurrencyModal;
